module.exports = __webpack_public_path__ + "img/SD.1bfc002e.png";